import RootStore from '../../../Core/mobx/RootStore';
import {useState} from 'react';
import {TemplatePurposes, TemplateTypes} from './EmailEditor';
import API from '../../../APIs/API';
import {User} from '../../../Auth/User';
import {useTemplateData} from '../../../Core/hooks/useTemplateData';
import EmailEditorDialog from './EmailEditorDialog';
import {Grid} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {observer} from 'mobx-react-lite';

export const onEditorSend = async (
    emails: string[],
    html: string,
    productType: string,
    templatePurpose: TemplatePurposes,
    bcc?: string[],
    subject?: string,
    illustration?: string,
) => {
    const email = RootStore.agentPortalStore.contactsFormStore.contact ?? emails[0];
    const customerId = RootStore.agentPortalStore.contactsFormStore.id;
    const emailSubject = subject || 'Your Life Insurance Estimate';

    const res = await API.Call<{success: boolean; message: string}>('v2/internal/amplify-iul/ap-email', 'POST', {
        recipients: emails.map((e) => ({address: e})),
        bcc,
        subject: emailSubject,
        html,
        productType,
        templatePurpose,
        illustration,
        customerId,
    });
    if (res) {
        RootStore.uiStore.showSnackbar(res.message, res.success ? 'success' : 'error');
    } else {
        const isAfterSaleProsper = productType === 'Prosper' && templatePurpose === TemplatePurposes.afterSale;
        RootStore.uiStore.showSnackbar(
            isAfterSaleProsper
                ? 'There was an issue sending your email. Please ensure you have completed the instant application.'
                : 'There was an issue sending your email',
            'error',
        );
    }

    await API.Call(`crm/email-engagement/${email}`, 'POST', {
        type: 'EMAIL',
        metadata: {
            from: {
                email: User.Info.email,
                firstName: User.Info.name,
                lastName: '',
            },
            cc: [],
            to: emails.map((x) => {
                return {
                    email: x,
                };
            }),
            bcc: bcc?.map((x) => {
                return {
                    email: x,
                };
            }),
        },
        subject: emailSubject,
        html,
    });
};

export const EmailEditorSelection = observer(() => {
    const familyQuoteStore = RootStore.familyQuoteStore;
    const [purpose, setPurpose] = useState(TemplatePurposes.quoted);
    const uiStore = RootStore.uiStore;

    const familyData = familyQuoteStore.selectedQuotes.map((q) => useTemplateData(q?.singleQuote, q?.combinedQuote));
    const templateType = TemplateTypes.quoteFamily;
    const emails = familyQuoteStore.selectedQuotes.map((q) => q.singleQuote.email);

    return (
        <>
            <EmailEditorDialog
                open={uiStore.emailDialog}
                onClose={() => uiStore.toggleEmailDialog()}
                onSend={(
                    emails: string[],
                    html: string,
                    productType: string,
                    templatePurpose: TemplatePurposes,
                    bccEmails?: string[],
                    subject?: string,
                    illustration?: string,
                ) => {
                    onEditorSend(emails, html, productType, templatePurpose, bccEmails, subject, illustration).then(
                        () => {
                            uiStore.toggleEmailDialog();
                        },
                    );
                }}
                currentEmails={emails}
                templatePurpose={purpose}
                templateType={templateType}
                templateData={familyData}
            ></EmailEditorDialog>
            {!!familyQuoteStore.selectedQuotes.length && (
                <div
                    style={{
                        position: 'fixed',
                        bottom: 50,
                        right: 50,
                        zIndex: 99,
                        padding: '10px 20px 10px 20px',
                        borderRadius: 15,
                        backgroundColor: '#ffff',
                        boxShadow: '0px 0px 5px #aaa',
                        width: 270,
                    }}
                >
                    <Grid alignItems={'center'} justify={'center'} style={{textAlign: 'center'}}>
                        <div>
                            <strong>Selected {familyQuoteStore.selectedQuotes.length} quotes</strong>
                        </div>
                        <Grid>
                            <Button
                                variant="outlined"
                                color="primary"
                                style={{marginTop: 12}}
                                onClick={() => uiStore.toggleEmailDialog()}
                            >
                                Send Email
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                style={{marginTop: 12, marginLeft: 10}}
                                onClick={() => {
                                    setPurpose(TemplatePurposes.afterSale);
                                    uiStore.toggleEmailDialog();
                                }}
                            >
                                After Sale
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            )}
        </>
    );
});
